// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../common/Components/Loader.bs.js");
let Sentry = require("../../../reason/Sentry.bs.js");
let Scalars = require("../../../scalars/Scalars.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let Container = require("../../common/Components/Container.bs.js");
let PageTitle = require("../../common/Components/PageTitle.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let MainLayout = require("../../common/Components/MainLayout.bs.js");
let Responsive = require("../../../uikit/reason/helpers/Responsive.bs.js");
let UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
let Heading__Jsx3 = require("../../../uikit/reason/helpers/Heading__Jsx3.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ErrorComponent = require("../../common/Components/ErrorComponent.bs.js");
let ContentBox__Jsx3 = require("../../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyWizardRelay = require("../propertyWizard/PropertyWizardRelay.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("../propertyWizard/PropertyWizardFormRelay.bs.js");
let PropertyWizardQueryParams = require("../propertyWizard/PropertyWizardQueryParams.bs.js");
let NewPropertyPageRelayFormData = require("./NewPropertyPageRelayFormData.bs.js");
let NewPropertyPageRelayQuery_graphql = require("../../../__generated__/NewPropertyPageRelayQuery_graphql.bs.js");
let NewPropertyPageRelay_query_graphql = require("../../../__generated__/NewPropertyPageRelay_query_graphql.bs.js");
let NewPropertyPageRelayRefetchQuery_graphql = require("../../../__generated__/NewPropertyPageRelayRefetchQuery_graphql.bs.js");
let NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql = require("../../../__generated__/NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.bs.js");

function NewPropertyPageRelay$Layout(props) {
  return JsxRuntime.jsx(MainLayout.make, {
    children: JsxRuntime.jsx(Container.make, {
      children: props.children
    })
  });
}

let Layout = {
  make: NewPropertyPageRelay$Layout
};

function NewPropertyPageRelay$ErrorShowingDraft(props) {
  return JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
    children: JsxRuntime.jsx(ErrorComponent.make, {
      message: "There was a problem getting the draft. Please refresh or try again later."
    })
  });
}

let ErrorShowingDraft = {
  make: NewPropertyPageRelay$ErrorShowingDraft
};

let convertFragment = NewPropertyPageRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NewPropertyPageRelay_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NewPropertyPageRelay_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NewPropertyPageRelay_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NewPropertyPageRelay_query_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = NewPropertyPageRelayRefetchQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = NewPropertyPageRelayRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(NewPropertyPageRelay_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

let DataFragment_draftV5Status_decode = NewPropertyPageRelay_query_graphql.Utils.draftV5Status_decode;

let DataFragment_draftV5Status_fromString = NewPropertyPageRelay_query_graphql.Utils.draftV5Status_fromString;

let DataFragment = {
  draftV5Status_decode: DataFragment_draftV5Status_decode,
  draftV5Status_fromString: DataFragment_draftV5Status_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable
};

let convertVariables = NewPropertyPageRelayQuery_graphql.Internal.convertVariables;

let convertResponse = NewPropertyPageRelayQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = NewPropertyPageRelayQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables, NewPropertyPageRelayQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, NewPropertyPageRelayQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(NewPropertyPageRelayQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(NewPropertyPageRelayQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(NewPropertyPageRelayQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(NewPropertyPageRelayQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertFragment$1 = NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function NewPropertyPageRelay$AlreadyPublishedProperty(props) {
  let property = RescriptRelay_Fragment.useFragment(NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1, props.property);
  let id = property.id;
  if (id === undefined) {
    return JsxRuntime.jsx(NewPropertyPageRelay$ErrorShowingDraft, {});
  }
  let onTanAt = property.onTanAt;
  let tmp;
  if (onTanAt !== undefined) {
    let match = property.propertyLocation;
    if (match !== undefined && match.__typename === "PropertyLocationWithVisibleAddress") {
      let address = match.address;
      if (address !== undefined) {
        let locationDisplay = match.locationDisplay;
        if (locationDisplay !== undefined) {
          let distanceFromNow = UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(Primitive_option.valFromOption(onTanAt)));
          tmp = JsxRuntime.jsxs("div", {
            children: [
              address + `, ` + locationDisplay + ` was published `,
              distanceFromNow + ` ago`
            ],
            className: "text-lg"
          });
        } else {
          tmp = null;
        }
      } else {
        tmp = null;
      }
    } else {
      tmp = null;
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(ViewStack.make, {
        space: Responsive.make("sm", "md", undefined, undefined, undefined, undefined, undefined),
        flexDirection: "column",
        children: [
          JsxRuntime.jsx(Heading__Jsx3.make, {
            as_: "h2",
            children: "This draft has already been published"
          }),
          tmp,
          JsxRuntime.jsx("div", {
            children: "Do you wish to view the property's public page, edit the property, or start a new property draft?",
            className: "text-lg"
          })
        ]
      }),
      JsxRuntime.jsxs(ViewStack.make, {
        mt: "lg",
        space: Responsive.make("sm", "md", undefined, undefined, undefined, undefined, undefined),
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            href: `/properties/` + id,
            children: "VIEW"
          }),
          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            href: `/properties/` + id + `/edit`,
            children: "EDIT"
          }),
          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            href: `/properties/new`,
            children: "NEW"
          })
        ]
      })
    ]
  });
}

let AlreadyPublishedProperty = {
  PropertyFragment: PropertyFragment,
  SecondaryButton: undefined,
  make: NewPropertyPageRelay$AlreadyPublishedProperty
};

function NewPropertyPageRelay$Inner(props) {
  let draftId = props.draftId;
  let data = use$1({
    hasDraftId: Stdlib_Option.isSome(draftId),
    id: Stdlib_Option.getOr(draftId, "")
  }, undefined, undefined, undefined);
  let match = React.useTransition();
  let startRefetchTransition = match[1];
  let match$1 = useRefetchable(data.fragmentRefs);
  let refetch = match$1[1];
  let agent = UserSession.useAgentInfo();
  let handleVisibilityChange = React.useCallback(_e => {
    let visibilityState = Webapi__Dom__Document.visibilityState(document);
    if (visibilityState === "Visible") {
      return startRefetchTransition(() => {
        refetch({
          hasDraftId: Stdlib_Option.isSome(draftId),
          id: Stdlib_Option.getOr(draftId, "")
        }, "network-only", undefined);
      });
    }
  }, [
    startRefetchTransition,
    refetch,
    draftId
  ]);
  React.useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [handleVisibilityChange]);
  let match$2 = match$1[0].draftV5;
  let tmp;
  if (match$2 !== undefined) {
    switch (match$2.__typename) {
      case "DraftV5" :
        if (match$2.chapter !== undefined) {
          let match$3 = match$2.status;
          let exit = 0;
          if (match$3 !== undefined && (match$3 === "DELETED" || match$3 === "RESUMABLE_DRAFT" || match$3 === "DRAFT" || match$3 === "PUBLISHED" || match$3 === "EXPIRED")) {
            switch (match$3) {
              case "DELETED" :
                tmp = JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
                  children: JsxRuntime.jsx(ContentBox__Jsx3.make, {
                    hasShadow: true,
                    children: "This draft has been deleted"
                  })
                });
                break;
              case "EXPIRED" :
                tmp = JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
                  children: JsxRuntime.jsx(ContentBox__Jsx3.make, {
                    hasShadow: true,
                    children: "This draft has expired"
                  })
                });
                break;
              default:
                exit = 1;
            }
          } else {
            exit = 1;
          }
          if (exit === 1) {
            tmp = JsxRuntime.jsx(PropertyWizardRelay.make, {
              draftData: NewPropertyPageRelayFormData.toDraftData(match$2.fragmentRefs),
              draftDbId: match$2.databaseId
            });
          }
        } else {
          Sentry.captureErrorMessage("Missing chapter timeZone in new property page", true, undefined, "NewPropertyPageRelay.res", 169, {
            currentUser: agent
          }, undefined, undefined);
          tmp = JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
            children: JsxRuntime.jsx(ErrorComponent.make, {
              message: "We encountered a problem while loading your account settings... Please refresh or try again later"
            })
          });
        }
        break;
      case "NotAuthorizedError" :
        tmp = JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
          children: JsxRuntime.jsx(ErrorComponent.make, {
            message: `The draft with id ` + Stdlib_Option.getOr(draftId, "-") + ` does not belong to you`
          })
        });
        break;
      case "PublishedPropertyDraft" :
        let property = match$2.property;
        tmp = property !== undefined ? JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
            children: JsxRuntime.jsx(ContentBox__Jsx3.make, {
              paddingFull: true,
              hasShadow: true,
              children: JsxRuntime.jsx(NewPropertyPageRelay$AlreadyPublishedProperty, {
                property: property.fragmentRefs
              })
            })
          }) : JsxRuntime.jsx(NewPropertyPageRelay$ErrorShowingDraft, {});
        break;
      case "NotFoundError" :
      case "__unselected" :
        tmp = JsxRuntime.jsx(NewPropertyPageRelay$ErrorShowingDraft, {});
        break;
    }
  } else {
    tmp = draftId !== undefined ? JsxRuntime.jsx(NewPropertyPageRelay$ErrorShowingDraft, {}) : JsxRuntime.jsx(PropertyWizardRelay.make, {});
  }
  return JsxRuntime.jsxs(PropertyWizardFormRelay.Context.Provider.make, {
    mode: React.useMemo(() => "New", []),
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Broadcast Property"
      }),
      tmp
    ]
  });
}

let Inner = {
  make: NewPropertyPageRelay$Inner
};

function NewPropertyPageRelay(props) {
  let match = PropertyWizardQueryParams.use();
  let draftId = match[0].draftId;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Broadcast Property"
      }),
      JsxRuntime.jsx(React.Suspense, {
        children: JsxRuntime.jsx(NewPropertyPageRelay$Inner, {
          draftId: draftId
        }),
        fallback: JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Loader.make, {}),
            className: "my-[32px]"
          })
        })
      })
    ]
  });
}

let QueryParams;

let Document;

let make = NewPropertyPageRelay;

let $$default = NewPropertyPageRelay;

exports.QueryParams = QueryParams;
exports.Document = Document;
exports.Layout = Layout;
exports.ErrorShowingDraft = ErrorShowingDraft;
exports.DataFragment = DataFragment;
exports.Query = Query;
exports.AlreadyPublishedProperty = AlreadyPublishedProperty;
exports.Inner = Inner;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
